import { RouteObject } from 'react-router-dom';

import { AppNotFoundPage, MainLayout } from '@/components';
import { Support } from '@/features/support';

import { Home } from './Home';

export const homeRoute: RouteObject = {
  element: <MainLayout />,
  children: [
    { path: 'home', element: <Home /> },
    { path: 'support', element: <Support /> },
    { path: '*', element: <AppNotFoundPage /> },
  ],
};
